import { render, staticRenderFns } from "./LetterboxListItem.vue?vue&type=template&id=61bd68fa&scoped=true&"
import script from "./LetterboxListItem.vue?vue&type=script&lang=ts&"
export * from "./LetterboxListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bd68fa",
  null
  
)

export default component.exports